<div class="financial-dashboard-component">
    <app-header
        [title]="'support.dashboard.header.title' | translate"
        [subtitle]="'support.dashboard.header.subtitle' | translate"
        [hasBackButton]="false"
    >
        <div class="input-group">
            <span class="input-group-text">
                <i-feather name="calendar"></i-feather>
            </span>
            <select class="form-select" [(ngModel)]="selectedMonthFilter">
                @for (month of lastMonthsLabel; track month; let index = $index) {
                    <option [value]="index">{{ month }}</option>
                }
            </select>
        </div>
        <div class="plan-filter input-group">
            <span class="input-group-text">
                <i-feather name="filter"></i-feather>
            </span>
            <select class="form-select" [(ngModel)]="selectedPlanFilter">
                <option [value]="0">{{ 'support.dashboard.header.plan-filter.all-plans' | translate }}</option>
                <option [value]="1">{{ 'support.dashboard.header.plan-filter.popular' | translate }}</option>
                <option [value]="2">{{ 'support.dashboard.header.plan-filter.v8' | translate }}</option>
                <option [value]="3">{{ 'support.dashboard.header.plan-filter.turbo' | translate }}</option>
            </select>
        </div>
    </app-header>
    <ng-scrollbar>
        <main>
            <app-financial-dashboard-data
                #transactedValueTotalSection
                sectionTitle="support.dashboard.dashboard-data.title.transacted-value-total"
                loaderName="transactedValueTotal"
                [dashboardData]="transactedValueTotalData"
                (onReload)="getTransactedValueTableData()"

                [hasWorkingDaysCount]="false"
            />

            <app-financial-dashboard-data
                #transactedValueUntilTodaySection
                sectionTitle="{{'support.dashboard.dashboard-data.title.transacted-value-until-today' | translate: { day: actualDay } }}"
                loaderName="transactedValue"
                [dashboardData]="transactedValueUntilTodayData"
                (onReload)="getTransactedValueTableData()"
            />

            <app-financial-dashboard-data
                #transactedValueByWorkingDaySection
                sectionTitle="support.dashboard.dashboard-data.title.transacted-value-per-working-day"
                loaderName="transactedValueByWorkingDay"
                [dashboardData]="transactedValueByWorkingDayData"
                (onReload)="getTransactedValueTableData()"
            />

            <app-financial-dashboard-data
                #transactedValueByDaySection
                sectionTitle="support.dashboard.dashboard-data.title.transacted-value-last-working-days"
                loaderName="transactedValueByDay"
                [dashboardData]="transactedValueByDay"
                (onReload)="getTransactedValueByDayData()"

                [hasTable]="false"
                [hasBestMonth]="false"
            />

            <app-financial-dashboard-data
                #transactedCommerceValueSection
                sectionTitle="support.dashboard.dashboard-data.title.transacted-value-parts-commerce"
                loaderName="transactedCommerceValue"
                [dashboardData]="transactedCommerceValueData"
                (onReload)="getTransactedCommerceValueTableData()"

                [hasWorkingDaysCount]="false"
                [hasGraph]="false"
            />

            <app-financial-dashboard-data
                #transactedCommerceValueGraphSection
                sectionTitle="support.dashboard.dashboard-data.title.transacted-value-parts-commerce"
                loaderName="transactedCommerceValueGraph"
                [dashboardData]="transactedCommerceValueData"
                (onReload)="getTransactedCommerceValueTableData()"

                [isCommerceGraph]="true"
                [hasWorkingDaysCount]="false"
                [hasTable]="false"
                [hasBestMonth]="false"
            />

            <app-financial-dashboard-data
                #transactedCashbackValueSection
                sectionTitle="support.dashboard.dashboard-data.title.cashback-volume"
                loaderName="transactedCashbackValue"
                [dashboardData]="transactedCashbackValueData"
                (onReload)="getTransactedCashbackValueTableData()"

                [isCashback]="true"
                [filterOptions]="selectCashbackOptions"
                (onFilter)="selectCashbackFilter($event)"
            ></app-financial-dashboard-data>
        </main>
    </ng-scrollbar>
</div>

<ngx-ui-loader [loaderId]="'loader-principal'"></ngx-ui-loader>
